export interface WorldCupTeamBranding {
  fifaCode: string;
  flagEmoji: string;
  primaryColor: string;
  secondaryColor: string;
  aliases?: string[];
}

const normalizeKey = (value: string): string =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");

export const WORLD_CUP_TEAM_BRANDING_BY_CODE: Record<string, WorldCupTeamBranding> = {
  ALG: { fifaCode: "ALG", flagEmoji: "🇩🇿", primaryColor: "#006233", secondaryColor: "#D21034", aliases: ["Algeria"] },
  ARG: { fifaCode: "ARG", flagEmoji: "🇦🇷", primaryColor: "#74ACDF", secondaryColor: "#FFFFFF", aliases: ["Argentina"] },
  AUS: { fifaCode: "AUS", flagEmoji: "🇦🇺", primaryColor: "#012169", secondaryColor: "#FFCD00", aliases: ["Australia"] },
  AUT: { fifaCode: "AUT", flagEmoji: "🇦🇹", primaryColor: "#ED2939", secondaryColor: "#FFFFFF", aliases: ["Austria"] },
  BEL: { fifaCode: "BEL", flagEmoji: "🇧🇪", primaryColor: "#000000", secondaryColor: "#FFD90C", aliases: ["Belgium"] },
  BIH: {
    fifaCode: "BIH",
    flagEmoji: "🇧🇦",
    primaryColor: "#002395",
    secondaryColor: "#FECB00",
    aliases: ["Bosnia-Herzegovina", "Bosnia and Herzegovina", "Bosnia Herzegovina"],
  },
  BRA: { fifaCode: "BRA", flagEmoji: "🇧🇷", primaryColor: "#009C3B", secondaryColor: "#FFDF00", aliases: ["Brazil"] },
  CAN: { fifaCode: "CAN", flagEmoji: "🇨🇦", primaryColor: "#D80621", secondaryColor: "#FFFFFF", aliases: ["Canada"] },
  CIV: { fifaCode: "CIV", flagEmoji: "🇨🇮", primaryColor: "#F77F00", secondaryColor: "#009E60", aliases: ["Ivory Coast", "Cote d Ivoire", "Cote d'Ivoire"] },
  COD: { fifaCode: "COD", flagEmoji: "🇨🇩", primaryColor: "#007FFF", secondaryColor: "#CE1021", aliases: ["Congo DR", "DR Congo", "Democratic Republic of the Congo"] },
  COL: { fifaCode: "COL", flagEmoji: "🇨🇴", primaryColor: "#FCD116", secondaryColor: "#003893", aliases: ["Colombia"] },
  CPV: { fifaCode: "CPV", flagEmoji: "🇨🇻", primaryColor: "#003893", secondaryColor: "#CF2027", aliases: ["Cape Verde Islands", "Cape Verde"] },
  CRO: { fifaCode: "CRO", flagEmoji: "🇭🇷", primaryColor: "#FF0000", secondaryColor: "#171796", aliases: ["Croatia"] },
  CUW: { fifaCode: "CUW", flagEmoji: "🇨🇼", primaryColor: "#002B7F", secondaryColor: "#FCD116", aliases: ["Curacao", "Curaçao"] },
  CZE: { fifaCode: "CZE", flagEmoji: "🇨🇿", primaryColor: "#11457E", secondaryColor: "#D7141A", aliases: ["Czechia", "Czech Republic"] },
  ECU: { fifaCode: "ECU", flagEmoji: "🇪🇨", primaryColor: "#FFDD00", secondaryColor: "#034EA2", aliases: ["Ecuador"] },
  EGY: { fifaCode: "EGY", flagEmoji: "🇪🇬", primaryColor: "#CE1126", secondaryColor: "#000000", aliases: ["Egypt"] },
  ENG: { fifaCode: "ENG", flagEmoji: "🏴", primaryColor: "#C8102E", secondaryColor: "#FFFFFF", aliases: ["England"] },
  ESP: { fifaCode: "ESP", flagEmoji: "🇪🇸", primaryColor: "#AA151B", secondaryColor: "#F1BF00", aliases: ["Spain"] },
  FRA: { fifaCode: "FRA", flagEmoji: "🇫🇷", primaryColor: "#0055A4", secondaryColor: "#EF4135", aliases: ["France"] },
  GER: { fifaCode: "GER", flagEmoji: "🇩🇪", primaryColor: "#000000", secondaryColor: "#DD0000", aliases: ["Germany"] },
  GHA: { fifaCode: "GHA", flagEmoji: "🇬🇭", primaryColor: "#CE1126", secondaryColor: "#FCD116", aliases: ["Ghana"] },
  HAI: { fifaCode: "HAI", flagEmoji: "🇭🇹", primaryColor: "#00209F", secondaryColor: "#D21034", aliases: ["Haiti"] },
  IRN: { fifaCode: "IRN", flagEmoji: "🇮🇷", primaryColor: "#239F40", secondaryColor: "#DA0000", aliases: ["Iran", "IR Iran"] },
  IRQ: { fifaCode: "IRQ", flagEmoji: "🇮🇶", primaryColor: "#CE1126", secondaryColor: "#000000", aliases: ["Iraq"] },
  JOR: { fifaCode: "JOR", flagEmoji: "🇯🇴", primaryColor: "#007A3D", secondaryColor: "#CE1126", aliases: ["Jordan"] },
  JPN: { fifaCode: "JPN", flagEmoji: "🇯🇵", primaryColor: "#BC002D", secondaryColor: "#FFFFFF", aliases: ["Japan"] },
  KOR: { fifaCode: "KOR", flagEmoji: "🇰🇷", primaryColor: "#CD2E3A", secondaryColor: "#0047A0", aliases: ["South Korea", "Korea Republic", "Republic of Korea"] },
  KSA: { fifaCode: "KSA", flagEmoji: "🇸🇦", primaryColor: "#006C35", secondaryColor: "#FFFFFF", aliases: ["Saudi Arabia"] },
  MAR: { fifaCode: "MAR", flagEmoji: "🇲🇦", primaryColor: "#C1272D", secondaryColor: "#006233", aliases: ["Morocco"] },
  MEX: { fifaCode: "MEX", flagEmoji: "🇲🇽", primaryColor: "#006847", secondaryColor: "#CE1126", aliases: ["Mexico"] },
  NED: { fifaCode: "NED", flagEmoji: "🇳🇱", primaryColor: "#AE1C28", secondaryColor: "#21468B", aliases: ["Netherlands"] },
  NOR: { fifaCode: "NOR", flagEmoji: "🇳🇴", primaryColor: "#BA0C2F", secondaryColor: "#00205B", aliases: ["Norway"] },
  NZL: { fifaCode: "NZL", flagEmoji: "🇳🇿", primaryColor: "#00247D", secondaryColor: "#CC142B", aliases: ["New Zealand"] },
  PAN: { fifaCode: "PAN", flagEmoji: "🇵🇦", primaryColor: "#005293", secondaryColor: "#D21034", aliases: ["Panama"] },
  PAR: { fifaCode: "PAR", flagEmoji: "🇵🇾", primaryColor: "#D52B1E", secondaryColor: "#0038A8", aliases: ["Paraguay"] },
  POR: { fifaCode: "POR", flagEmoji: "🇵🇹", primaryColor: "#006600", secondaryColor: "#FF0000", aliases: ["Portugal"] },
  QAT: { fifaCode: "QAT", flagEmoji: "🇶🇦", primaryColor: "#8A1538", secondaryColor: "#FFFFFF", aliases: ["Qatar"] },
  RSA: { fifaCode: "RSA", flagEmoji: "🇿🇦", primaryColor: "#007749", secondaryColor: "#FFB612", aliases: ["South Africa"] },
  SCO: { fifaCode: "SCO", flagEmoji: "🏴", primaryColor: "#0065BF", secondaryColor: "#FFFFFF", aliases: ["Scotland"] },
  SEN: { fifaCode: "SEN", flagEmoji: "🇸🇳", primaryColor: "#00853F", secondaryColor: "#FDEF42", aliases: ["Senegal"] },
  SUI: { fifaCode: "SUI", flagEmoji: "🇨🇭", primaryColor: "#D52B1E", secondaryColor: "#FFFFFF", aliases: ["Switzerland"] },
  SWE: { fifaCode: "SWE", flagEmoji: "🇸🇪", primaryColor: "#006AA7", secondaryColor: "#FECC00", aliases: ["Sweden"] },
  TUN: { fifaCode: "TUN", flagEmoji: "🇹🇳", primaryColor: "#E70013", secondaryColor: "#FFFFFF", aliases: ["Tunisia"] },
  TUR: { fifaCode: "TUR", flagEmoji: "🇹🇷", primaryColor: "#E30A17", secondaryColor: "#FFFFFF", aliases: ["Turkey", "Türkiye"] },
  USA: { fifaCode: "USA", flagEmoji: "🇺🇸", primaryColor: "#3C3B6E", secondaryColor: "#B22234", aliases: ["United States", "United States of America", "USA"] },
  URY: { fifaCode: "URY", flagEmoji: "🇺🇾", primaryColor: "#6CB4EE", secondaryColor: "#0038A8", aliases: ["Uruguay"] },
  UZB: { fifaCode: "UZB", flagEmoji: "🇺🇿", primaryColor: "#1EB53A", secondaryColor: "#0099B5", aliases: ["Uzbekistan"] },
};

const WORLD_CUP_TEAM_BRANDING_BY_NAME = new Map<string, WorldCupTeamBranding>();

for (const branding of Object.values(WORLD_CUP_TEAM_BRANDING_BY_CODE)) {
  for (const alias of branding.aliases ?? []) {
    WORLD_CUP_TEAM_BRANDING_BY_NAME.set(normalizeKey(alias), branding);
  }
}

export function getWorldCupTeamBrandingByCode(code?: string | null): WorldCupTeamBranding | null {
  if (!code) {
    return null;
  }

  return WORLD_CUP_TEAM_BRANDING_BY_CODE[code.trim().toUpperCase()] ?? null;
}

export function getWorldCupTeamBrandingForTeam(input: {
  fifaCode?: string | null;
  name?: string | null;
}): WorldCupTeamBranding | null {
  const byCode = getWorldCupTeamBrandingByCode(input.fifaCode);
  if (byCode) {
    return byCode;
  }

  if (!input.name) {
    return null;
  }

  return WORLD_CUP_TEAM_BRANDING_BY_NAME.get(normalizeKey(input.name)) ?? null;
}
